// extracted by mini-css-extract-plugin
export default {"table":"product-selectors_table__-+fj2","tableRow":"product-selectors_tableRow__rC0K6","actionsCell":"product-selectors_actionsCell__-5sGW"};